import { useAppBridge } from '@shopify/app-bridge-react';

export function useSafeAppBridge() {
    try {
        return useAppBridge();
    } catch {
        return null;
    }
}